import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { ValueToCollection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { Translation } from '@morningtrain/react-translations'
import DoubleColumn from 'widgets/economy/partials/DoubleColumn'
import TotalPerGuest from 'support/displays/TotalPerGuest'

export default function AvgBasketSizeTableCalculatedEmployee ({ mode = 'employees' }) {
  return (
    <UI.Card tight className="pt-6 sm:pt-10">
      <UI.CardHeader withPadding>
        <UI.SecondaryHeading>
          <Displays.Text name="key"/>
        </UI.SecondaryHeading>
      </UI.CardHeader>
      <ValueToCollection name="collection">
        <Table striped withFooter>
          <Columns.Column
            label={<Translation name="generic.employee"/>}
            footer={<Translation name="generic.total"/>}
          >
            <UI.WithSubtitle subtitle={<Displays.Text name="department.name"/>}>
              <Displays.Text name="Employee_name"/>
            </UI.WithSubtitle>
            </Columns.Column>

          <Columns.Integer
            name="Average_Basket_Size"
            alignment="center"
            label={<Translation name="columns.avg_with_discounts"/>}
            footer={(
              <Displays.AggregateRatio
                name="revenue_total"
                outOfName="avg_basket_size"
                display={<Displays.Integer/>}
              />
            )}
          />
          <Columns.Integer
            name="Average_Basket_Size"
            alignment="center"
            label={<Translation name="columns.avg_without_discounts"/>}
            footer={(
              <Displays.AggregateRatio
                name="revenue_total"
                outOfName="avg_basket_size"
                display={<Displays.Integer/>}
              />
            )}
          />
          <Columns.Integer
            name="Average_Basket_Size_Restaurant"
            alignment="center"
            className="border-l"
            label={<Translation name="columns.avg_inhouse_with_discounts"/>}
            footer={(
              <Displays.AggregateRatio
                name="revenue_inhouse"
                outOfName="basket_size_restaurant"
                display={<Displays.Integer/>}
              />
            )}
          />
          <Columns.Integer
            name="Guest_Count_Restaurant"
            alignment="center"
            label={<Translation name="columns.amount_inhouse"/>}
            aggregate="sum"
          />
          <Columns.Integer
            name="Average_Basket_Take_Away"
            alignment="center"
            className="border-l"
            label={<Translation name="columns.avg_takeaway_with_discounts"/>}
            footer={(
              <Displays.AggregateRatio
                name="revenue_takeaway"
                outOfName="basket_size_take_away"
                display={<Displays.Integer/>}
              />
            )}
          />
          <Columns.Integer
            name="Guest_Count_TakeAway"
            alignment="center"
            label={<Translation name="columns.amount_takeaway"/>}
            aggregate="sum"
          />
          <Columns.Column
            className="border-l"
            alignment="center"
            label={(
              <UI.WithSubtitle subtitle={(
                <UI.Text size="xs">
                  <Translation name="generic.restaurant"/> / <Translation name="generic.takeaway"/>
                </UI.Text>
              )}
              >
                <Translation name="columns.beverages_per_guest"/>
              </UI.WithSubtitle>
            )}
            display={(
              <DoubleColumn
                firstDisplay={(
                  <UI.Text color="black">
                    <Displays.Ratio name='Total_Beverages_Restaurant'
                                    outOfName='Guest_Count_Restaurant' display={<Displays.Number/>} />
                  </UI.Text>
                )}
                secondDisplay={(
                  <UI.Text color="black">
                    <Displays.Ratio name='Total_Beverages_TakeAway'
                                    outOfName='Guest_Count_TakeAway' display={<Displays.Number/>} />
                  </UI.Text>
                )}
              />
            )}
            footer={(
              <DoubleColumn
                firstDisplay={<TotalPerGuest unitType="Beverages" location="Restaurant"/>}
                secondDisplay={<TotalPerGuest unitType="Beverages" location="TakeAway"/>}
              />
            )}
          />
          <Columns.Column
            alignment="center"
            label={(
              <UI.WithSubtitle subtitle={(
                <UI.Text size="xs">
                  <Translation name="generic.restaurant"/> / <Translation name="generic.takeaway"/>
                </UI.Text>
              )}
              >
                <Translation name="columns.food_items_per_guest"/>
              </UI.WithSubtitle>
            )}
            display={(
              <DoubleColumn
                firstDisplay={(
                  <UI.Text color="black">
                    <Displays.Ratio name='Total_FoodItems_Restaurant'
                                    outOfName='Guest_Count_Restaurant' display={<Displays.Number/>} />
                  </UI.Text>
                )}
                secondDisplay={(
                  <UI.Text color="black">
                    <Displays.Ratio name='Total_FoodItems_TakeAway'
                                    outOfName='Guest_Count_TakeAway' display={<Displays.Number/>} />
                  </UI.Text>
                )}
              />
            )}
            footer={(
              <DoubleColumn
                firstDisplay={<TotalPerGuest unitType="FoodItems" location="Restaurant"/>}
                secondDisplay={<TotalPerGuest unitType="FoodItems" location="TakeAway"/>}
              />
            )}
          />
        </Table>
      </ValueToCollection>
    </UI.Card>
  )
}
